import axios from "axios";
import { BASEURL } from "../utils/helper";
import { apiPaths } from "../utils/apiUtils";

const axiosInstance = axios.create({
  baseURL: BASEURL,
});

let resetCounter = () => {
  console.log("Reset counter function not set yet.");
};

axiosInstance.interceptors.response.use(
  (response) => {
    resetCounter();
    return response;
  },
  (error) => {
    if(error.response && error.response.status === 401 && error.response.data.error.error === 'Unauthorized') {
      if(error.config.url !== '/api/v1/user')
        window.location.href = `${window.location.origin}${apiPaths.Oauth}/logout`;
    }
    if(error.response && error.response.status === 403)
      resetCounter();

    return Promise.reject(error);
  }
);

const api = (axios) => {
  return {
    get: (url, config = {}) =>
      axios.get(url, { ...config, headers: { ...config.headers }, withCredentials: true }),

    delete: (url, config = {}) =>
      axios.delete(url, { ...config, headers: { ...config.headers }, withCredentials: true }),

    post: (url, body, config = {}) =>
      axios.post(url, body, { ...config, headers: { ...config.headers }, withCredentials: true }),

    put: (url, body, config = {}) =>
      axios.put(url, body, { ...config, headers: { ...config.headers }, withCredentials: true }),
  };
};

// Function to set the reset callback from the custom hook
export function setResetCallback(callback) {
  resetCounter = callback;
}

export default api(axiosInstance);
